import React from "react";

import HelpSearch from "../help/help-search";
import { useCommonContext } from "../../context/common-context";

import { BreadCrumb } from "../../common/breadcrumb";
import Categories from "../../common/categories";
import { ContactCards } from "./constants";
import "../help/help.scss";
import "./contactus.scss";

const restrictChatBanner = ["safeway","vons"];

const ContactUs = ({}) => {
  const {
    user,
    appData: { banner },
    isGuest,
  } = useCommonContext();

  let filteredCards;
  if (!restrictChatBanner.includes(banner)) {
    // If the banner is in the restrictChatBanner array, add the cards with id 4
    filteredCards = ContactCards.filter(card => card.id !== 4);
  } else {
    // If the banner is not in the restrictChatBanner array, include all cards except those with id 4
    filteredCards = ContactCards;
  }

  const breadCrumblist = [
    {
      label: "Contact Us",
      href: "/help/home",
    },
    {
      label: "Other ways to contact us",
    },
  ];

  return (
    <div className="help-wrapper contact-wrapper">
      <BreadCrumb list={breadCrumblist} />
      <HelpSearch isGuest={isGuest} banner={banner} />
      <Categories
        isGuest={isGuest}
        banner={banner}
        user={user}
        data={filteredCards}
        title="Other ways to contact us"
      />
      <div id="nuance-chat-fixed-1"></div>
    </div>
  );
};

export default ContactUs;
